import { createSlice } from '@reduxjs/toolkit';
import { brandGetLandingPage } from './brandAsyncThunk';

const brandGetLandingPageSlice = createSlice({
  name: "brand",
  initialState: {
    payload: {},
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [brandGetLandingPage.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [brandGetLandingPage.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = { ...action.payload.list };
    },
    [brandGetLandingPage.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default brandGetLandingPageSlice.reducer;